import React from 'react'

import { useDisclosure, UseDisclosureReturn } from '@chakra-ui/hooks'

import { useLocation } from 'react-router-dom'

import type { ProviderProps } from '../helpers/types/context/auth.types'

type SidebarDrawerContextData = UseDisclosureReturn

export const SidebarDrawerContext = React.createContext(
  {} as SidebarDrawerContextData
)

export function SidebarDrawerProvider({ children }: ProviderProps) {
  const location = useLocation()
  const disclosure = useDisclosure()

  React.useEffect(() => {
    disclosure.onClose()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname])

  return (
    <SidebarDrawerContext.Provider value={disclosure}>
      {children}
    </SidebarDrawerContext.Provider>
  )
}
